// A PDF document opened full screen in the site's PDF viewer (aldoo-ra/PDFViewer): the storefront's and the
// editor's, so a buyer reads a datasheet without leaving the page.
import React, { useMemo } from "react"
import Modal from "aldoo-ra/Modal"
import PDFViewer from "aldoo-ra/PDFViewer"

const VIEWER = {
  container: "w-screen h-[100dvh] max-w-none bg-white border-0 rounded-none shadow-none overflow-hidden flex flex-col p-0 m-0",
  header: "relative flex items-center h-[56px] pl-4 pr-[64px] shrink-0 border-b border-black/10",
  title: "flex-1 min-w-0 m-0 text-[16px] md:text-[18px] font-bold truncate",
  closeButton: "absolute right-3 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full hover:bg-black/5 flex items-center justify-center transition-colors",
  closeIcon: "h-6 w-6",
  contentWrapper: "flex-1 min-h-0 overflow-hidden",
  content: "h-full min-h-0 p-0",
}

/** `texts`: the viewer's words in the page's language (aldoo-ra/PDFViewer TEXTS keys). */
export default function DocumentViewer({ document, texts, onClose }) {
  const download = useMemo(() => () => window.open(document.url, "_blank", "noopener"), [document.url])
  return (
    <Modal isOpen onClose={onClose} variant="fullscreen" title={document.name} closeOnEscape styleOverrides={VIEWER}>
      <div className="w-full h-full" data-testid="document-viewer">
        <PDFViewer src={document.url} height="calc(100dvh - 56px)" onDownload={download} texts={texts} />
      </div>
    </Modal>
  )
}
